import React from 'react';
import { createPortal } from 'react-dom';
import './InfoModal.css'; // InfoModalのCSSを流用
import { getUILoc } from '../../utils/cardUtils.js';

const TutorialModal = ({ step, onNext, isTransparent = false }) => {
    // textまたはtextIdが存在しない場合はモーダルを表示しない
    if (!step || (!step.text && !step.textId)) {
        return null;
    }

    const displayText = step.text || (step.textId ? getUILoc(`TUTORIAL.${step.textId}`) : '');

    const modalContent = (
        <div 
            className="info-modal-overlay" 
            style={{ 
                backgroundColor: isTransparent ? 'transparent' : 'rgba(0, 0, 0, 0.7)',
                pointerEvents: isTransparent ? 'none' : 'auto',
                zIndex: 13000 // チュートリアルハイライト(2000)より確実に上に
            }}
        >
            <div 
                className="info-modal-content"
                style={{ pointerEvents: 'auto' }} // モーダル自体はクリック可能に
            >
                <div className="info-modal-header">
                    <h3>{getUILoc('LABELS.TUTORIAL_TITLE')}</h3>
                </div>
                <div className="info-modal-body">
                    <p style={{ whiteSpace: 'pre-wrap' }}>{displayText}</p>
                </div>
                <div className="info-modal-footer">
                    <button onClick={onNext} className="info-modal-ok-button">
                        {getUILoc('BUTTONS.CONFIRM')}
                    </button>
                </div>
            </div>
        </div>
    );

    return createPortal(modalContent, document.body);
};

export default TutorialModal;
